/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import classNames from "classnames";
import {
  Sidebar,
  SidebarCollapse,
  SidebarItem,
  SidebarItemGroup,
  SidebarItems,
  TextInput,
} from "flowbite-react";
import type { FC } from "react";
import { useEffect, useState } from "react";

import { CgGym } from "react-icons/cg";
import { GiWeightLiftingUp } from "react-icons/gi";
import {
  HiChartBar,
  HiChartPie,
  HiPaperClip,
  HiSearch,
  HiUserGroup,
  HiUsers,
  HiVideoCamera,
  HiMusicNote,
  HiCash,
} from "react-icons/hi";
import { IoIosNotifications } from "react-icons/io";

import { useSidebarContext } from "../context/SidebarContext";
import isSmallScreen from "../helpers/is-small-screen";

const ExampleSidebar: FC = function () {
  const { isOpenOnSmallScreens: isSidebarOpenOnSmallScreens } =
    useSidebarContext();

  const [currentPage, setCurrentPage] = useState("");

  useEffect(() => {
    const newPage = window.location.pathname;

    setCurrentPage(newPage);
  }, [setCurrentPage]);

  return (
    <div
      className={classNames("lg:block!", {
        hidden: !isSidebarOpenOnSmallScreens,
      })}
    >
      <Sidebar
        aria-label="Sidebar with multi-level dropdown example"
        collapsed={isSidebarOpenOnSmallScreens && !isSmallScreen()}
      >
        <div className="flex h-full flex-col justify-between py-2">
          <div>
            <form className="pb-3 md:hidden">
              <TextInput
                icon={HiSearch}
                type="search"
                placeholder="Search"
                required
                size={32}
              />
            </form>
            <SidebarItems>
              <SidebarItemGroup>
                <SidebarItem
                  href="/"
                  icon={HiChartPie}
                  className={
                    "/" === currentPage ? "bg-gray-100 dark:bg-gray-700" : ""
                  }
                >
                  Dashboard
                </SidebarItem>

                <SidebarCollapse
                  icon={HiCash}
                  label="Membership"
                  open={currentPage.startsWith("/membership")}
                  className={
                    currentPage.startsWith("/membership")
                      ? "bg-gray-100 dark:bg-gray-700"
                      : ""
                  }
                >
                  <SidebarItem
                    href="/membership/invites"
                    className={
                      "/membership/invites" === currentPage
                        ? "bg-gray-100 dark:bg-gray-700"
                        : ""
                    }
                  >
                    Invites
                  </SidebarItem>
                  <SidebarItem
                    href="/membership/manual-onboarding"
                    className={
                      "/membership/manual-onboarding" === currentPage
                        ? "bg-gray-100 dark:bg-gray-700"
                        : ""
                    }
                  >
                    Manual Onboarding
                  </SidebarItem>
                  <SidebarItem
                    href="/membership/ab-testing"
                    className={
                      "/membership/ab-testing" === currentPage
                        ? "bg-gray-100 dark:bg-gray-700"
                        : ""
                    }
                  >
                    A/B Testing
                  </SidebarItem>
                  <SidebarItem
                    href="/membership/settings"
                    className={
                      "/membership/settings" === currentPage
                        ? "bg-gray-100 dark:bg-gray-700"
                        : ""
                    }
                  >
                    Settings
                  </SidebarItem>
                </SidebarCollapse>

                <SidebarItem
                  href="/programs"
                  icon={HiPaperClip}
                  className={
                    "/programs" === currentPage
                      ? "bg-gray-100 dark:bg-gray-700"
                      : ""
                  }
                >
                  Programs
                </SidebarItem>

                <SidebarCollapse
                  icon={CgGym}
                  label="Workouts"
                  open={
                    currentPage.startsWith("/music-workouts") ||
                    currentPage.startsWith("/traditional-workouts")
                  }
                  className={
                    currentPage.startsWith("/music-workouts") ||
                    currentPage.startsWith("/traditional-workouts")
                      ? "bg-gray-100 dark:bg-gray-700"
                      : ""
                  }
                >
                  <SidebarItem
                    href="/music-workouts"
                    className={
                      "/music-workouts" === currentPage
                        ? "bg-gray-100 dark:bg-gray-700"
                        : ""
                    }
                  >
                    Music Workouts
                  </SidebarItem>
                  <SidebarItem
                    href="/traditional-workouts"
                    className={
                      currentPage.startsWith("/traditional-workouts")
                        ? "bg-gray-100 dark:bg-gray-700"
                        : ""
                    }
                  >
                    Traditional Workouts
                  </SidebarItem>
                </SidebarCollapse>

                <SidebarItem
                  href="/exercises"
                  icon={GiWeightLiftingUp}
                  className={
                    "/exercises" === currentPage
                      ? "bg-gray-100 dark:bg-gray-700"
                      : ""
                  }
                >
                  Exercises
                </SidebarItem>

                <SidebarItem
                  href="/media"
                  icon={HiVideoCamera}
                  className={
                    "/media" === currentPage
                      ? "bg-gray-100 dark:bg-gray-700"
                      : ""
                  }
                >
                  Media
                </SidebarItem>

                <SidebarItem
                  href="/trainers"
                  icon={HiUserGroup}
                  className={
                    "/trainers" === currentPage
                      ? "bg-gray-100 dark:bg-gray-700"
                      : ""
                  }
                >
                  Athletes
                </SidebarItem>

                <SidebarItem
                  href="/users/list"
                  icon={HiUsers}
                  className={
                    "/users/list" === currentPage
                      ? "bg-gray-100 dark:bg-gray-700"
                      : ""
                  }
                >
                  Users
                </SidebarItem>

                <SidebarItem
                  href="/spotlight"
                  icon={HiChartBar}
                  className={
                    "/spotlight" === currentPage
                      ? "bg-gray-100 dark:bg-gray-700"
                      : ""
                  }
                >
                  Spotlight
                </SidebarItem>
                <SidebarItem
                  href="/notifications"
                  icon={IoIosNotifications}
                  className={
                    "/notifications" === currentPage
                      ? "bg-gray-100 dark:bg-gray-700"
                      : ""
                  }
                >
                  Notifications
                </SidebarItem>
                <SidebarItem
                  href="/radio"
                  icon={HiMusicNote}
                  className={
                    "/radio" === currentPage
                      ? "bg-gray-100 dark:bg-gray-700"
                      : ""
                  }
                >
                  Radio
                </SidebarItem>
              </SidebarItemGroup>
            </SidebarItems>
          </div>
        </div>
      </Sidebar>
    </div>
  );
};

export default ExampleSidebar;
